import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '@c2fo/liquidity';
import { useAgreementsUrl } from '@/utils/useAgreementsUrl';
import HelpSection from './HelpSection';
import TrustpilotWidget from './TrustpilotWidget';

// Reason: C2FO's own support cards and Trustpilot rating read as the partner's when they sit under
// third-party finance content (Mondu, J.P. Morgan, Fundbox), so these pages get the legal row only.
const LEGAL_ONLY_FOOTER_PATHS = [
  'extended-network-finance',
  'extended-network-finance/get-a-quote',
  'termloansbyfundbox',
];

const Footer = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const year = new Date().getFullYear();
  const { privacyLink, termsOfUseLink } = useAgreementsUrl();
  const showFooter = !pathname.includes('build-offer');
  const legalOnly = LEGAL_ONLY_FOOTER_PATHS.some((path) => pathname.includes(path));

  return showFooter ? (
    <div className="mx-auto mb-10 max-w-screen-2xl px-4 lg:mt-10 lg:px-6">
      <div className="mx-4 lg:mx-8">
        {!legalOnly && <HelpSection />}
        <div className={cn('text-xs', !legalOnly && 'mt-10')}>
          <div className="space-x-2 text-center">
            <span className="inline">{t('core.legalCopyright', { year })}</span>
            <span className="inline-block">|</span>
            <a className="inline-block text-blue-500" rel="noreferrer" target="_blank" href={privacyLink}>
              {t('footer.privacyPolicyLinkText')}
            </a>
            <span className="inline-block">|</span>
            <a className="inline-block text-blue-500" rel="noreferrer" target="_blank" href={termsOfUseLink}>
              {t('footer.supplierAgreementLinkText')}
            </a>
          </div>
          {!legalOnly && (
            <div className="mt-2">
              <TrustpilotWidget />
            </div>
          )}
        </div>
      </div>
    </div>
  ) : null;
};

export default Footer;
